import React, { useEffect, useState, useCallback, useContext, createContext } from "react";
import useHttp from "../hooks/use-http";
import AppContext from "./app-context";
import { useMutation } from "@apollo/client";
import { B3_POST_BUNDLE_AUTHORIZATION } from "../graphql/mutations/bundleAuthorization";
import { setCookie } from "nookies";

const AuthContext = createContext({
  isLoggedIn: false,
  sessionUser: {},
  bundleAuth: {},
  customerPrimaryAddresses: {},
});

export const AuthContextProvider = (props) => {
  const [isLoading, setIsLoading] = useState(true);
  const [isAPIError, setIsAPIError] = useState(false);
  const [errorMsg, setErrorMsg] = useState("Error fetching data...");
  //const [isLoggedIn, setIsLoggedIn] = useState(false);
  const [sessionUser, setSessionUser] = useState({});
  const {
    isLoadingBioradResources,
    errorGetBioradResources,
    sendRequest: getSessionUser,
  } = useHttp();
  const [customerPrimaryAddresses, setCustomerPrimaryAddresses] = useState();

  const [jwtToken, setJwtToken] = useState();
  const [b3AuthToken, setB3AuthToken] = useState(false);
  const {
    isLoadingJwtToken,
    errorJwtToken,
    sendRequest: getJwtToken,
  } = useHttp();

  const [
    bundleAuthMutation,
    { data: bundleAuth, loading: bundleAuthLaoding, error: bundleAuthError },
  ] = useMutation(B3_POST_BUNDLE_AUTHORIZATION);

  const appCtx = useContext(AppContext);

  useEffect(() => {
    const setSessionUserData = (responseData) => {
      const data = (typeof responseData === 'string') ? JSON.parse(responseData) : responseData;
      setSessionUser(data);
      //setIsLoggedIn(data.loggedIn);
    }

    if(appCtx.envProp && appCtx.envProp.appServer){
      const sessionUserURL = appCtx.envProp.appServer + "sessionUser";

      getSessionUser(
        { url: sessionUserURL },
        setSessionUserData,
        "json"
      ).catch((error) => {
        console.log("Error fetching session user details");
      });

    }
  },[appCtx.envProp.appServer])

  useEffect(() =>{
    if (sessionUser && sessionUser.loggedIn && sessionUser.hasAccount && (!jwtToken || !jwtToken.token) && !sessionUser?.b2bUser) {
      setIsLoading(true);
      const setJwtTokenData = (jwtTokenData) => {
        setJwtToken(jwtTokenData);
        const bundleAuthVariables = {
          input: { channelId: 1, bcToken: jwtTokenData.token },
        };
        bundleAuthMutation({
          variables: bundleAuthVariables,
        });
        setIsLoading(false);
      };
      //getQuoteHandler();
      getJwtToken(
        {
          url: "/customer/current.jwt?app_client_id="+appCtx.envProp.app_client_id,
          headers: {
            Accept: "application/json",
            "Content-Type": "application/json",
          },
        },
        setJwtTokenData,
        "json"
      ).catch((error) => {
        if (error && error.message) {
          setErrorMsg(error.message);
        }
        setIsAPIError(true);
        setIsLoading(false);
      });
    }
  },[sessionUser])

  const fetchCustomerFormFields = useCallback(async(customerID) => {
    fetch(appCtx.envProp.appServer + "external/stores/" + appCtx.envProp.store_hash + "/v3/customers/form-field-values?customer_id="+customerID)
      .then((response) => {
        return response.json();
      })
      .then((data) => {
        if(data && data.data && data.data.length){
          const defaultAddresses = data.data.find(
            (e) => e.name === "Default Address"
          );
          if(defaultAddresses?.value){
            const custAddrJSON = JSON.parse(defaultAddresses.value);
            //console.log("custAddrJSON: " + (custAddrJSON ? JSON.stringify(custAddrJSON): ""));
            let addressJSON = {};
            for (let i = 0; i < custAddrJSON.length; i++) {
              addressJSON[custAddrJSON[i].companyId] = custAddrJSON[i];
            }
            //console.log("addressJSON: " + (addressJSON ? JSON.stringify(addressJSON): ""));
            setCustomerPrimaryAddresses(addressJSON);
          }
        }
      })
      .catch((error) => {
        console.log(error);
      });
  });

  useEffect(()=>{
    if(bundleAuth?.authorization?.result?.user?.entityId){
      fetchCustomerFormFields(bundleAuth?.authorization?.result?.user?.entityId);
    }
  },[bundleAuth])

  useEffect(() => {
    const getB3AuthToken = async () => {
      try {
        const response = await fetch(appCtx.envProp.appServer + "external/user/token/b3AuthToken", {
          method: "GET",
        });
        const data = await response.json();
        console.log("getB3Auth");
        if(!data.success){
          //reset b3_auth_token
          const resResponse = await fetch(appCtx.envProp.appServer + "external/user/refreshB3Token", {
            method: "GET",
          })
          const resdata=await resResponse.json();
          console.log("resetB3");
          setB3AuthToken(resdata.success);
        }else{
         setB3AuthToken(data.success);
        }
      } catch (error) {
        console.log("Error getting B3Auth: ",error);
        setB3AuthToken(false);
      }
    }
    if(sessionUser || appCtx.envProp.appServer){
      console.log("user: ", sessionUser.loggedIn," url: ", appCtx.envProp.appServer)
    }
    if (sessionUser && sessionUser.loggedIn) {
      console.log("UserLoggedIn:",sessionUser.loggedIn)
      getB3AuthToken();
    }
  }, [sessionUser, appCtx.envProp.appServer])
  return (
    <AuthContext.Provider value={{
      isLoggedIn: sessionUser ? sessionUser.loggedIn : false,
      sessionUser: sessionUser,
      bundleAuth: bundleAuth,
      b3AuthToken: b3AuthToken,
      customerPrimaryAddresses: customerPrimaryAddresses,
       }}>
      {props.children}
    </AuthContext.Provider>
  );
};

export default AuthContext;
